import { useState } from 'react';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleConsultationSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d3vlu3ug28apfrolkkl0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      
      if (response.ok) {
        alert('お問い合わせを受け付けました。担当者より3営業日以内にご連絡いたします。');
        (e.target as HTMLFormElement).reset();
      } else {
        alert('送信に失敗しました。しばらく時間をおいてから再度お試しください。');
      }
    } catch (error) {
      alert('送信に失敗しました。しばらく時間をおいてから再度お試しください。');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/5c26ea124169faad7b14e2aca6cd535c/e51d8c57c29021be5858c9fa0847c48e.jpeg" 
                alt="Georgia-Japan Bridge Logo" 
                className="w-12 h-12 object-contain"
              />
              <h1 className="text-2xl font-bold text-gray-900 tracking-wide" style={{ fontFamily: '"Noto Sans JP", sans-serif', letterSpacing: '0.05em' }}>
                Georgia-Japan Bridge
              </h1>
            </div>
            <nav className="hidden md:flex space-x-8">
              <a href="#about" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                サービス概要
              </a>
              <a href="#comparison" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                各国比較
              </a>
              <a href="#georgia" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                ジョージアの魅力
              </a>
              <a href="#consultation" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                無料相談
              </a>
            </nav>
            <button
              className="md:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
          {isMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-100">
              <nav className="flex flex-col space-y-4">
                <a href="#about" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                  サービス概要
                </a>
                <a href="#comparison" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                  各国比較
                </a>
                <a href="#georgia" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                  ジョージアの魅力
                </a>
                <a href="#consultation" className="text-gray-700 hover:text-gray-900 transition-colors cursor-pointer">
                  無料相談
                </a>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-50 to-blue-50 py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
                なぜ今、海外で会社を持つ人が
                <br />
                増えているのか
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                日本国内での課税負担、円安、社会保険料上昇、過剰な行政手続き。経営者が自由を求めて海外へと目を向け始めている現実があります。海外法人設立は脱税ではなく、防御と設計なのです。
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="#consultation"
                  className="inline-flex items-center justify-center px-8 py-3 bg-slate-900 text-white font-medium rounded-lg hover:bg-slate-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  無料相談を予約する
                </a>
                <a
                  href="#about"
                  className="inline-flex items-center justify-center px-8 py-3 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  詳細を見る
                </a>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/2e02d8cb277862ab64bcd5570677c165.jpg"
                alt="国際ビジネス展開のイメージ"
                className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              海外法人設立の一般的なメリット
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              節税ではなく、資産構造の最適化という観点から海外法人設立の意義を考えてみましょう。
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-global-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">所得・資産の国際分散</h3>
              <p className="text-gray-600">
                単一国家への依存リスクを軽減し、経済的な安定性を向上させます。
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-calculator-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">税負担の軽減</h3>
              <p className="text-gray-600">
                合法的な繰延や低税率により、効率的な資産運用が可能になります。
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-exchange-dollar-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">外貨での資産保有</h3>
              <p className="text-gray-600">
                為替リスクの分散と、国際的な投資機会へのアクセスが向上します。
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-send-plane-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">国際送金・決済の自由度</h3>
              <p className="text-gray-600">
                スムーズな国際取引と、柔軟な資金移動が実現できます。
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-building-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">海外事業への足がかり</h3>
              <p className="text-gray-600">
                投資・貿易・不動産などの海外事業展開の基盤となります。
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">資産保護</h3>
              <p className="text-gray-600">
                政治的・経済的リスクから資産を守る構造的な防御策となります。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section id="comparison" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              代表的な海外法人地域の比較
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              各地域の特徴を中立的な視点で比較し、最適な選択肢を見つけましょう。
            </p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8 mb-12">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Dubai%20UAE%20skyline%20with%20modern%20skyscrapers%20and%20business%20district%2C%20luxury%20business%20environment%2C%20golden%20hour%20lighting%2C%20prestigious%20corporate%20atmosphere&width=80&height=80&seq=dubai-flag&orientation=squarish"
                  alt="ドバイ"
                  className="w-16 h-16 rounded-lg object-cover object-top mr-4"
                />
                <h3 className="text-2xl font-bold text-gray-900">ドバイ（UAE）</h3>
              </div>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">無税構造・高いブランドイメージ</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">設立・維持コストが非常に高額</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">オフィス実体要求・滞在要件が厳格</span>
                </div>
              </div>
              <p className="text-gray-600 mt-6">
                資産管理には適していますが、運営負荷が大きく中小規模には不向きです。
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Singapore%20modern%20business%20district%20with%20Marina%20Bay%20financial%20center%2C%20clean%20urban%20environment%2C%20professional%20corporate%20setting%2C%20contemporary%20architecture&width=80&height=80&seq=singapore-flag&orientation=squarish"
                  alt="シンガポール"
                  className="w-16 h-16 rounded-lg object-cover object-top mr-4"
                />
                <h3 className="text-2xl font-bold text-gray-900">シンガポール</h3>
              </div>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">国際的信用・安定した法制度</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">法人税17%、維持費・人件費が高い</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">中小規模にはコスト過多</span>
                </div>
              </div>
              <p className="text-gray-600 mt-6">
                大企業には適していますが、自由な事業拠点としては負担が重いのが現実です。
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Hong%20Kong%20skyline%20with%20Victoria%20Harbor%20and%20financial%20district%2C%20urban%20business%20environment%2C%20modern%20city%20landscape%2C%20corporate%20atmosphere&width=80&height=80&seq=hongkong-flag&orientation=squarish"
                  alt="香港"
                  className="w-16 h-16 rounded-lg object-cover object-top mr-4"
                />
                <h3 className="text-2xl font-bold text-gray-900">香港</h3>
              </div>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-check-line text-green-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">従来は魅力的な税制</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">近年の政治・法制度変化で不透明化</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-close-line text-red-500 mt-1 mr-3"></i>
                  <span className="text-gray-700">銀行口座開設の難化</span>
                </div>
              </div>
              <p className="text-gray-600 mt-6">
                金融アクセスが制限され、将来の不確実性が高まっている状況です。
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              これらの地域は魅力はあるものの、柔軟性と自由度には限界があります。そこで注目されているのが、新しい選択肢としてのジョージアです。
            </p>
          </div>
        </div>
      </section>

      {/* Georgia Section */}
      <section id="georgia" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-8">
                ジョージアという新しい選択肢
              </h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-map-pin-line text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">戦略的立地</h3>
                    <p className="text-gray-600">ヨーロッパとアジアの中間に位置する戦略的拠点として機能します。</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-government-line text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">小さな政府・シンプルな税制</h3>
                    <p className="text-gray-600">低コストでの設立が可能で、複雑な手続きがありません。</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-user-line text-purple-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">外国人100%出資可能</h3>
                    <p className="text-gray-600">資本金要件なしで、完全に自由な法人設立が可能です。</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-percent-line text-orange-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">分配時課税型法人税制度</h3>
                    <p className="text-gray-600">利益分配時のみ課税される革新的な税制システムです。</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-time-line text-teal-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">迅速な手続き</h3>
                    <p className="text-gray-600">登記は数日で完了、銀行口座もリモートで開設可能です。</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center mr-4 mt-1">
                    <i className="ri-computer-line text-red-600"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">完全オンライン管理</h3>
                    <p className="text-gray-600">現地に居住せず、全ての経理・申告・管理をオンラインで完結できます。</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 p-6 bg-blue-50 rounded-xl">
                <p className="text-lg text-blue-900 font-medium">
                  自由の構造がここにあります。ジョージアは、真の経営の自由を求める方々にとって、最も合理的な選択肢なのです。
                </p>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/5c26ea124169faad7b14e2aca6cd535c/4f2951314b1728605cd6424baf1d3e99.jpeg"
                alt="ジョージアのビジネス環境"
                className="w-full h-96 lg:h-[500px] object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Support Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              私たちの役割
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              多くの日本人が自分でやってみたが途中で挫折した現実があります。書類、銀行、法制度の壁を最短で突破し、確実に法人設立・口座開設まで導く専門サポートです。
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-text-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">書類作成・申請</h3>
              <p className="text-gray-600">
                複雑な書類作成から申請手続きまで、全てを代行いたします。
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-bank-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">銀行口座開設</h3>
              <p className="text-gray-600">
                現地銀行との連携により、確実な口座開設をサポートします。
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-scales-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">法制度対応</h3>
              <p className="text-gray-600">
                現地の法制度に精通した専門家が、安全な設立をガイドします。
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">継続サポート</h3>
              <p className="text-gray-600">
                設立後の税務サポートまで、一貫して伴走いたします。
              </p>
            </div>
          </div>
          
          <div className="mt-16 bg-white p-8 lg:p-12 rounded-2xl shadow-lg">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">
                  現地との連携チームを背景に
                </h3>
                <p className="text-gray-600 mb-6">
                  ジョージア現地の法律事務所、会計事務所、銀行との強固なネットワークを構築しています。これにより、日本にいながらにして、現地と同等のサービスを受けることが可能です。
                </p>
                <ul className="space-y-3">
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    <span className="text-gray-700">現地法律事務所との直接連携</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    <span className="text-gray-700">認定会計士による税務サポート</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    <span className="text-gray-700">主要銀行との口座開設ルート確保</span>
                  </li>
                  <li className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    <span className="text-gray-700">日本語での完全サポート体制</span>
                  </li>
                </ul>
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20team%20meeting%20in%20modern%20office%2C%20international%20collaboration%2C%20diverse%20professionals%20working%20together%2C%20clean%20corporate%20environment%2C%20trust%20and%20expertise%20atmosphere&width=500&height=400&seq=team-support&orientation=landscape"
                  alt="専門サポートチーム"
                  className="w-full h-80 object-cover object-top rounded-xl"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              信頼と法令順守
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              海外法人設立は脱法ではなく、国際的なリスク分散と経済的自立のための知的行動です。
            </p>
          </div>
          
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">CRS対応</h3>
              <p className="text-gray-600">
                共通報告基準に完全準拠した、透明性の高い法人設立をサポートします。
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-shield-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">租税条約活用</h3>
              <p className="text-gray-600">
                日本・ジョージア間の租税条約を適切に活用した、合法的な税務設計を行います。
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-global-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">CFC対応</h3>
              <p className="text-gray-600">
                外国子会社合算税制を考慮した、安全で持続可能な法人構造を設計します。
              </p>
            </div>
          </div>
          
          <div className="mt-16 bg-slate-900 text-white p-8 lg:p-12 rounded-2xl">
            <div className="text-center">
              <h3 className="text-2xl font-bold mb-6">構造を変えて自由を得る</h3>
              <p className="text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
                これは単なる節税手法ではありません。グローバル化した現代において、経営者が自らの事業と資産を最適化し、真の経済的自立を実現するための知的戦略なのです。適切な法的枠組みの中で、新しい可能性を切り開いていきましょう。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Consultation Section */}
      <section id="consultation" className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
              あなたの会社を、世界のどこに置くか
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              それは、あなたの未来をどこに置くかということです。一歩を踏み出した瞬間から、経営の景色は変わります。無料相談から始めてください。私たちがその第一歩を導きます。
            </p>
          </div>
          
          <div className="bg-white p-8 lg:p-12 rounded-2xl shadow-lg">
            <form id="consultation-form" data-readdy-form onSubmit={handleConsultationSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    お名前 *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="山田太郎"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    メールアドレス *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="example@email.com"
                  />
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                    電話番号
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="090-1234-5678"
                  />
                </div>
                
                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                    会社名・事業内容
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="株式会社○○"
                  />
                </div>
              </div>
              
              <div>
                <label htmlFor="interest" className="block text-sm font-medium text-gray-700 mb-2">
                  ご関心のある内容 *
                </label>
                <select
                  id="interest"
                  name="interest"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">選択してください</option>
                  <option value="georgia-incorporation">ジョージア法人設立</option>
                  <option value="tax-optimization">税務最適化</option>
                  <option value="asset-protection">資産保護</option>
                  <option value="international-business">国際事業展開</option>
                  <option value="other">その他</option>
                </select>
              </div>
              
              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  ご質問・ご要望
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm resize-none"
                  placeholder="具体的なご質問やご要望がございましたら、お聞かせください。（500文字以内）"
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">500文字以内でご入力ください</p>
              </div>
              
              <div className="text-center">
                <button
                  type="submit"
                  className="inline-flex items-center justify-center px-8 py-4 bg-slate-900 text-white font-medium rounded-lg hover:bg-slate-800 transition-colors cursor-pointer whitespace-nowrap text-lg"
                >
                  無料相談を予約する
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
              
              <p className="text-xs text-gray-500 text-center">
                ご入力いただいた情報は、お問い合わせ対応のみに使用し、第三者への提供は行いません。
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-4 gap-8">
            <div className="lg:col-span-2">
              <h3 className="text-2xl font-bold mb-4 tracking-wide" style={{ fontFamily: '"Noto Sans JP", sans-serif', letterSpacing: '0.05em' }}>
                Georgia-Japan Bridge LLC
              </h3>
              <p className="text-gray-300 mb-6">
                ジョージアでの法人設立を通じて、日本の経営者の皆様の国際的な事業展開と資産最適化をサポートいたします。
              </p>
              <div className="space-y-2">
                <p className="text-gray-300">
                  <span className="font-medium">代表者：</span>岡澤 隆
                </p>
                <p className="text-gray-300">
                  <span className="font-medium">所在地：</span>Tbilisi, Georgia
                </p>
                <p className="text-gray-300">
                  <span className="font-medium">Email：</span>info@georgiajapan.com
                </p>
                <p className="text-gray-300">
                  <span className="font-medium">Website：</span>https://georgiajapan.com
                </p>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">サービス</h4>
              <ul className="space-y-2">
                <li><a href="#georgia" className="text-gray-300 hover:text-white transition-colors cursor-pointer">ジョージア法人設立</a></li>
                <li><a href="#comparison" className="text-gray-300 hover:text-white transition-colors cursor-pointer">各国比較</a></li>
                <li><a href="#consultation" className="text-gray-300 hover:text-white transition-colors cursor-pointer">無料相談</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">法的情報</h4>
              <ul className="space-y-2">
                <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">利用規約</a></li>
                <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a></li>
                <li><a href="#" className="text-gray-300 hover:text-white transition-colors cursor-pointer">免責事項</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-700 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © 2025 Georgia-Japan Bridge LLC. All Rights Reserved.
              </p>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors text-sm mt-4 md:mt-0 cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Legal Disclaimer Modal */}
      <div className="fixed bottom-4 right-4 max-w-sm bg-white border border-gray-200 rounded-lg shadow-lg p-4 text-xs text-gray-600">
        <p className="mb-2">
          <strong>免責事項：</strong>本ページは一般的な情報提供を目的としており、特定の税務・法務アドバイスを構成するものではありません。
        </p>
        <p>
          具体的な適用可否については、必ず専門家または現地のコンサルタントにご確認ください。
        </p>
      </div>
    </div>
  );
}
